import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map, sortBy } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import DashboardCard from "../DashboardCard";

import { sizes } from "../../../constants/common";

import { formatDate } from "../../../utils/date";

const MdcLeastPerformingZones = (props) => {
  const { data } = props;

  return (
    <DashboardCard
      title={I18n.get("dashboard_leastPerformingZones")}
      size={sizes.xsmall}
      style={{
        margin: "12px",
        minWidth: "270px",
        flexGrow: 1,
        minHeight: "178px",
      }}
    >
      <Box
        className="text-54"
        style={{ paddingLeft: "145px", fontSize: "1em" }}
      >
        {I18n.get("dashboard_waitTime2")}
      </Box>
      <Grid
        container
        direction="column"
        style={{ height: "100%" }}
        wrap="nowrap"
      >
        {map(
          sortBy(get(data, ["card4"]), (z) => -get(z, ["time"])),
          (zone, index) => (
            <Grid item key={index}>
              <Grid container alignItems="center">
                <Grid
                  item
                  className="text-87 bold-500"
                  style={{
                    width: "130px",
                    textAlign: "right",
                    paddingRight: "15px",
                  }}
                >
                  {get(zone, ["name"])}
                </Grid>
                <Grid
                  item
                  className="text-87 bold-500"
                  style={{ fontSize: "1.7em" }}
                >
                  {get(zone, ["time"])
                    ? formatDate(get(zone, ["time"]) * 1000, "m[m] ss[s]")
                    : "-"}
                </Grid>
              </Grid>
            </Grid>
          )
        )}
      </Grid>
    </DashboardCard>
  );
};

export default MdcLeastPerformingZones;
